import Highcharts from 'highcharts';

import initNoData from 'highcharts/modules/no-data-to-display';

initNoData(Highcharts);

Highcharts.setOptions({
  lang: {
    noData: [
      'Keine Daten',
    ],
  },
});
